<template>
  <div class="modal-card" :class="$style.container">
    <ValidationObserver ref="observer" v-slot="{ invalid }">
      <header class="modal-card-head">
        <p class="modal-card-title">Add Site</p>
        <button type="button" class="delete" @click="$emit('close')" />
      </header>

      <section class="modal-card-body" :class="$style.body">
        <ValidationProvider
          v-slot="{ errors }"
          rules="required|max:255"
          name="Site Name"
        >
          <b-field
            label="Site Name"
            :message="errors[0]"
            :type="errors.length ? 'is-danger' : undefined"
          >
            <b-input
              v-model="name"
              placeholder="Name of institution or place to run data collection period"
            />
          </b-field>
        </ValidationProvider>

        <b-field label="Address">
          <b-input
            v-model="address"
            placeholder="Address of institution or place to run data collection period"
          />
        </b-field>

        <b-field label="Description" class="no-bottom-margin">
          <b-input
            v-model="description"
            type="textarea"
            placeholder="Description of the site (example : opening hours, phone number)"
          />
        </b-field>
      </section>

      <footer class="modal-card-foot">
        <button
          class="button is-primary is-rounded"
          @click="handleSubmit"
          :disabled="invalid"
        >
          Add Site
        </button>
      </footer>
    </ValidationObserver>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, Watch, Model } from 'vue-property-decorator';
import { State, Getter, Action, Mutation, namespace } from 'vuex-class';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { Site } from '@/store/modules/site/types/site.types';
import { RootState } from '@/store/store';
import { isTruthy } from '@/jbi-shared/util/watcher.vue-decorator';
import { ToastProgrammatic as Toast } from 'buefy';

@Component({
  components: {
    ValidationProvider,
    ValidationObserver,
  },
})
export default class CreateSiteForm extends Vue {
  public name = '';
  public address = '';
  public description = '';

  @Action('projects/getSites')
  public getSites!: () => void;

  @Action('projects/createSite')
  public createSite!: (newSite: Partial<Site>) => void;

  public async handleSubmit() {
    // @ts-ignore
    const isValid = await this.$refs.observer.validate();
    if (!isValid) {
      return;
    }

    const result = await this.createSite({
      name: this.name,
      address: this.address,
      description: this.description,
    });
    await this.getSites();

    this.$emit('submit', result);
    this.$emit('close');
    // TODO: this should track instead of toast
    Toast.open({
      queue: true,
      type: 'is-dark',
      position: 'is-top',
      message: `New Site Create Successfully`,
    });
  }
}
</script>

<style lang="scss" module>
.container {
}
</style>
